import React from 'react';

const CourseInfo = ({ course, formatCurrency }) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'published': return 'bg-green-100 text-green-800 border-green-200';
      case 'draft': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'pending': return 'bg-blue-100 text-blue-800 border-blue-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h3 className="font-semibold text-gray-900 mb-4">Course Information</h3>
      <div className="space-y-3 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600">Status</span>
          <span className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusColor(course.status)}`}>
            {course.status?.toUpperCase()}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Price</span>
          <span className="font-semibold">{formatCurrency(course.price)}</span>
        </div>
        {course.promoPrice && (
          <div className="flex justify-between">
            <span className="text-gray-600">Promo Price</span>
            <span className="font-semibold text-green-600">{formatCurrency(course.promoPrice)}</span>
          </div>
        )}
        <div className="flex justify-between">
          <span className="text-gray-600">Category</span>
          <span className="font-semibold">{course.category}</span>
        </div>
        {course.levelName && (
          <div className="flex justify-between">
            <span className="text-gray-600">Level</span>
            <span className="font-semibold">{course.levelName}</span>
          </div>
        )}
        {course.language && (
          <div className="flex justify-between">
            <span className="text-gray-600">Language</span>
            <span className="font-semibold">{course.language}</span>
          </div>
        )}
        <div className="flex justify-between">
          <span className="text-gray-600">Total Students</span>
          <span className="font-semibold">{course.totalStudents}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Total Duration</span>
          <span className="font-semibold">{course.duration}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Total Lectures</span>
          <span className="font-semibold">{course.lectures}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Last Updated</span>
          <span className="font-semibold">{course.lastUpdated}</span>
        </div>
        {course.instructorName && (
          <div className="flex justify-between">
            <span className="text-gray-600">Instructor</span>
            <span className="font-semibold">{course.instructorName}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CourseInfo;